import { applyMiddleware } from 'redux';
import { legacy_createStore as createStore } from 'redux';
import thunk from 'redux-thunk';
import { PERSIST, persistReducer, persistStore, PURGE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers';
import {
	createStateSyncMiddleware,
	initStateWithPrevTab
} from 'redux-state-sync';
import {
	SET_SELECTED_DOCUMENT_TABLE,
	SET_SELECTED_SECTION,
	SET_SELECTED_SIDEBAR_TAB,
	SET_UNSAVED_CHANGES
} from './types/types';

const persistConfig = {
	key: 'root',
	blacklist: ['sidebar', 'tablesQuickAccess'],
	storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const reduxStateSyncConfig = {
	blacklist: [
		PERSIST,
		PURGE,
		SET_SELECTED_SIDEBAR_TAB,
		SET_SELECTED_SECTION,
		SET_SELECTED_DOCUMENT_TABLE,
		SET_UNSAVED_CHANGES
	]
};
const middleWare = [thunk, createStateSyncMiddleware(reduxStateSyncConfig)];

const store = createStore(persistedReducer, {}, applyMiddleware(...middleWare));

initStateWithPrevTab(store);
const persistor = persistStore(store);
export { store, persistor };
